import { FC, PropsWithChildren, Ref } from 'react'
import cn from 'classnames'
import styles from './Row.module.scss'

interface RowProps {
  className?: string
  isAdditional?: boolean
  ref?: Ref<HTMLDivElement>
}
export const Row: FC<PropsWithChildren<RowProps>> = ({
  className,
  children,
  isAdditional = false,
  ref,
}) => {
  return (
    <div
      ref={ref}
      className={cn(className, styles.container, {
        [styles.isAdditional]: isAdditional,
      })}
    >
      {children}
    </div>
  )
}
